import script from "./DiscountFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./DiscountFormDialog.vue?vue&type=style&index=0&id=01d4059e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d4059e"]])

export default __exports__